export default "__VITE_ASSET__KliSFd4O__"